<template>
  <div class="signature-pad row">

    <!-- <div class="row">
      <div class="col-lg-12 col-md-12">
        <textarea class="m-2 form-control" name="" id="" cols="30" rows="5" v-model="currentField.instruction" v-if="inputShow.type == true"></textarea>
        <lable class="" v-if="inputShow.type == false"><span v-html="currentField.instruction"></span></lable>
      </div>
    </div> -->
    <!-- <div class="col-12">
      <div v-if="this.currentField.text">
       <small><p><strong>{{this.currentField.text}}</strong></p></small>
      </div>
      <div v-if="this.currentField.description">
        <small> <p>Details: <strong>{{this.currentField.description}}</strong></p></small>
      </div>
    </div> -->
     <div v-if=" isCheck == false || currentField.componentValue && currentField.componentValue.substr(currentField.componentValue.length - 4, 4) !== '.png'" class="col-12 img-fluid">
            <div class="d-flex  justify-content-end" >

            <VueSignaturePad
            id="signature"
            width="100%"
            height="200px"
            ref="signaturePad"
            :options="options"
            v-bind="attributesBinding"
            />
          </div>
          <div>
            <p class="text-success d-flex justify-content-end mt-2" v-if="isSetTime == true">Your signature confirm successfully <span><app-icon class="text-success" name="check-square"/></span></p>
          </div>
          <div class="mt-2 mb-2 w-100 d-flex  justify-content-end align-items-center" >
            <button @click.prevent="undo" class="btn btn-danger mr-2" v-bind="attributesBinding">Undo</button>
            <button @click.prevent="save" v-if="show != true" class="btn btn-success" v-bind="attributesBinding">Save</button>
          
            <!-- <button @click.prevent="change">Change Color</button>
            <button @click.prevent="resume">Resume Color</button> -->
          </div>  
     </div>
   
    <div class="col-lg-8 col-md-6 col-sm-12" v-if="isCheck == true">
      <p>{{ currentField.text }}</p>
      <app-avatar v-model="checkUrl" :title="$t('avatars')" :imgResponsiveness="'img-fluid'"
       class="mr-2 d-flex justify-content-end" avatar-class="avatars-w-200 " :img="currentField.componentValue"
       :alt-text="$t('not_found')"/>
     <br>
    <div class="d-flex justify-content-end" v-if="userRole.company_id != 1 && currentField.disabled == false">
      <a href="#" @click.prevent="isCheck = !isCheck">Change Signature</a>
    </div>
    </div>
  </div>
</template>

<script>
// import { createLogger } from 'vuex';
export default {
  name: "SignaturePad",
  props: ['currentField'],
  data: () => ({
    options: {
      penColor: "#000",
    },
    show: false,
    checkUrl: '',
    isCheck: null,
    isSetTime: false,
  }),
  methods: {
    undo() {
      this.show = false;
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      this.isSetTime = true;
      setTimeout(() => {
        this.isSetTime = false;
      }, 2000)
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      this.show = true;
      this.currentField.componentValue = data;
    },
  
  },
  created(){

  },
  mounted() {
    if(this.currentField.componentValue && this.currentField.componentValue.length == 0){
      this.isCheck = false
    }
    else{
      if(this.currentField.componentValue && this.currentField.componentValue.substr(this.currentField.componentValue.length - 4, 4) == '.png'){
      this.isCheck = true;
      }else{
          this.isCheck =  false
      }
    }

  },
  computed: {
    attributesBinding() {
      var attr = {};

      if (this.currentField.disabled) {
        attr.disabled = this.currentField.disabled;
      }
      return attr;
    },
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    inputShow() {
      return this.$store.state.inputMode;
    }
  },
};
</script>

<style>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  width: "100%";
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
</style>
